exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ErrorBoundary-module__error-screen___B5wKl{display:flex;justify-content:center;align-items:center;height:calc(var(--app-height) - 60px);padding:60px}.ErrorBoundary-module__error-screen___B5wKl .ErrorBoundary-module__wrapper___1I32N{display:flex;flex-direction:column;align-items:center}.ErrorBoundary-module__error-screen___B5wKl .ErrorBoundary-module__wrapper___1I32N img{width:500px;max-width:100%;margin-bottom:60px}.ErrorBoundary-module__error-screen___B5wKl .ErrorBoundary-module__wrapper___1I32N h2{text-align:center}.ErrorBoundary-module__error-screen___B5wKl .ErrorBoundary-module__wrapper___1I32N p{text-align:center;color:#b4bac3}", ""]);

// exports
exports.locals = {
	"error-screen": "ErrorBoundary-module__error-screen___B5wKl",
	"wrapper": "ErrorBoundary-module__wrapper___1I32N"
};